import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL;

console.log("🔌 Socket URL:", SOCKET_URL);

const socket = io(SOCKET_URL, {
  withCredentials: true,

  // IMPORTANT:
  // Allow Socket.IO to use polling first and upgrade to WebSocket.
  transports: ["polling", "websocket"],

  autoConnect: false,

  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  timeout: 10000,
});

socket.on("connect", () => {
  console.log("✅ Socket connected:", socket.id);
});

socket.on("connect_error", (error) => {
  console.error("❌ Socket connection error:", error.message);
  console.error("Socket URL:", SOCKET_URL);
});

socket.on("disconnect", (reason) => {
  console.log("❌ Socket disconnected:", reason);
});

export default socket;
